export const checkoutUrl = 'https://mindfulness-meditation-teacher-ready.impultienda.ar/checkout'

export const productName = 'Mindfulness & Meditation Teacher Ready™'

export const ctaLabel = 'GET THE COMPLETE TEACHING LIBRARY NOW'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/mGHpABmQh8VLSW7Xq1X7zw/Diseno_sin_titulo_(62).png'

export const price = {
  regular: 'USD 157.00',
  today: 'USD 27.00',
  value: 27,
}

export const comboIncludes = [
  '6 complete standalone systems in 1',
  '150+ complete sessions ready to teach',
  'Session Finder — the right practice in minutes',
  'Minute-by-minute session timing',
  'Teacher cueing & language library',
  'Silence windows & cue architecture',
  'Bonus 1 — 150 ready-to-teach sessions guide',
  'Bonus 2 — Cueing, language & troubleshooting mastery',
  'Bonus 3 — 75 class rescue sessions',
  'Bonus 4 — Workshops, retreats & events toolkit',
  'Bonus 5 — Business & program growth toolkit',
  '7-day money-back guarantee',
]

export const finalIncludes = [
  ...comboIncludes,
  'Adaptations, progressions & regressions',
  'Safety & professional boundaries guidance',
  'Instant access',
  'Pay in your local currency',
  'Ready-to-use PDF format',
]

export function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Mindfulness & Meditation Teacher Ready',
    value: price.value,
    currency: 'USD',
  })
}
